var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"increase-flow"},[_c('img',{attrs:{"src":require('@/assets/image/increase_flow.png'),"alt":""}}),_c('div',[_vm._v("WhatsApp")]),_c('div',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("(use original phone scan)")])])}
var staticRenderFns = []

export { render, staticRenderFns }